import React from "react";

// Client-side sparkline: counts of the talkgroup's calls per 5-minute bucket
// across the calls already loaded — no new API call.
function DemoSparkline({ callsData, talkgroupNum }) {
  if (!callsData || !talkgroupNum) return null;
  const BUCKET = 5 * 60 * 1000, N = 12;
  const now = Date.now();
  const counts = new Array(N).fill(0);
  callsData.ids.forEach((id) => {
    const c = callsData.entities[id];
    if (!c || c.talkgroupNum !== talkgroupNum) return;
    const age = now - new Date(c.time).getTime();
    const idx = N - 1 - Math.floor(age / BUCKET);
    if (idx >= 0 && idx < N) counts[idx] += 1;
  });
  const max = Math.max(1, ...counts);
  const W = 180, H = 34, bw = W / N;
  return (
    <svg className="demo-spark" width={W} height={H} viewBox={`0 0 ${W} ${H}`} aria-hidden="true">
      {counts.map((v, i) => {
        const h = Math.round((v / max) * (H - 4));
        return <rect key={i} x={i * bw + 1} y={H - h} width={bw - 2} height={h} rx="1" />;
      })}
    </svg>
  );
}
export default DemoSparkline;
